import { environment } from "@env/environment";
import { Guid } from "guid-typescript";
import { ACCUEIL, MON_PROFIL, NOS_OFFRES, NOUS_CONTACTER } from "@shared/constants/route.constants";
import { MemberAgreements } from "@shared/models/member-agreements.model";
export const DISCONNECT_BUTTON = "DECONNEXION";
export const POLICYDETAILS_BACK_BUTTON = "POLICYDETAILS_BACK_BUTTON";
export const Brands = {
  HM: "HM",
  MGEN: "MGEN",
  MNT: "MNT",
  VYV: "VYV",
} as const;

export interface BrandNavigationConfig {
  showAccueil: boolean;
  showProfil: boolean;
  showOffres: boolean;
  showContact: boolean;
  showDisconnectButton: boolean;
  showPolicyDetailsBackButton: boolean;
}

const defaultConfig: BrandNavigationConfig = {
  showAccueil: false,
  showProfil: true,
  showOffres: false,
  showContact: true,
  showDisconnectButton: false,
  showPolicyDetailsBackButton: false,
};

export const BRAND_NAVIGATION_CONFIG: Record<string, BrandNavigationConfig> = {
  [Brands.VYV]: {
    ...defaultConfig,
    showAccueil: true,
    showOffres: true,
    showDisconnectButton: true,
    showPolicyDetailsBackButton: true,
  },
  [Brands.HM]: { ...defaultConfig },
  [Brands.MGEN]: { ...defaultConfig },
  [Brands.MNT]: { ...defaultConfig },
};

export function getBrandNavigationConfig(brand: string): BrandNavigationConfig {
  return BRAND_NAVIGATION_CONFIG[brand] || defaultConfig;
}

export function isNavigationButtonVisible(buttonType: any): boolean {
  const config = getBrandNavigationConfig(environment.brand);

  switch (buttonType) {
    case ACCUEIL:
      return config.showAccueil;
    case MON_PROFIL:
      return config.showProfil;
    case NOS_OFFRES:
      return config.showOffres;
    case NOUS_CONTACTER:
      return config.showContact;
    case DISCONNECT_BUTTON:
      return config.showDisconnectButton;
    case POLICYDETAILS_BACK_BUTTON:
      return config.showPolicyDetailsBackButton;
    default:
      return true;
  }
}

export function filterAgreementVisibility(memberAgreements: MemberAgreements, policyId: Guid): MemberAgreements {
  if (environment.brand === Brands.VYV) return memberAgreements;
  return {
    agreements: memberAgreements.agreements.filter(a => a.id === policyId),
    policies: memberAgreements.policies.filter(p => p.id === policyId),
    quotations: [],
  };
}

export function isPartner(environment: any): boolean {
  return environment.brand === Brands.HM || environment.brand === Brands.MGEN || environment.brand === Brands.MNT;
}
